import React, { FC } from 'react';
import { Input, InputNumber } from 'antd';
import { useTranslation } from 'react-i18next';

import Form from '~/components/WizardForm';
import { LtrInput } from '~/components';
import buildNamePath from '~/utils/buildNamePath';
import InputsGroupLayout from '~/layouts/InputsGroupLayout';
import DropDown from '~/components/inputs/DropDown';

interface Props {
  hasEcom: boolean;
}

const CompanyInformationInputs: FC<Props> = (props) => {
  const { hasEcom } = props;
  const { t } = useTranslation('fillApplication');

  return (
    <InputsGroupLayout>
      <Form.Item name={n(['companyInformation', 'yearsInBusiness'])} label={t('Years in Business')}>
        <InputNumber />
      </Form.Item>
      <Form.Item name={n(['companyInformation', 'annualTurnover'])} label={t('Annual Turnover')}>
        <InputNumber stringMode precision={2} type="number" />
      </Form.Item>
      <Form.Item name={n(['companyInformation', 'numberOfEmployees'])} label={t('Number of Employees')}>
        <DropDown key="numberOfEmployees" dropDownKey="numberOfEmployees" itemKey="numberOfEmployees" />
      </Form.Item>
      {hasEcom && (
        <Form.Item name={n(['companyInformation', 'numberOfTransactions'])} label={t('Expected e-commerce turnover')}>
          <InputNumber />
        </Form.Item>
      )}
    </InputsGroupLayout>
  );
};

const n = buildNamePath('additionalInformation');

export default CompanyInformationInputs;
